import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  href,
  className = '',
  fullWidth = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center bg-orange hover:bg-orange/90 text-white font-bold py-4 px-8 rounded-full shadow-lg transform transition-all duration-200 hover:scale-105 hover:shadow-xl text-lg md:text-xl uppercase tracking-wide';
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={`${baseStyles} ${widthClass} ${className}`} target="_blank" rel="noopener noreferrer" data-id="element-10">
        {children}
        <ArrowRight className="ml-2 h-6 w-6" data-id="element-11" />
      </a>;
  }
  return <button className={`${baseStyles} ${widthClass} ${className}`} {...props} data-id="element-12">
      {children}
      <ArrowRight className="ml-2 h-6 w-6" data-id="element-13" />
    </button>;
}